"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SidebarItem;
exports.methodSpan = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.string.trim.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _MenuAction = require("./MenuAction");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const methodSpan = exports.methodSpan = function methodSpan() {
  let request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const method = (request === null || request === void 0 ? void 0 : request.toLowerCase()) || '';
  switch (method) {
    case 'get':
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("b", {
        className: "badge_verb--get"
      }, "GET"), "\xA0");
    case 'post':
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("b", {
        className: "badge_verb--post"
      }, "POST"), "\xA0");
    case 'patch':
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("b", {
        className: "badge_verb--patch"
      }, "PATCH"), "\xA0");
    case 'delete':
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("b", {
        className: "badge_verb--delete"
      }, "DELETE"), "\xA0");
    default:
      return /*#__PURE__*/_react.default.createElement("span", null);
  }
};
// Slug / Path from title creator
const slugForURL = function slugForURL() {
  let title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (title === null || title === void 0 ? void 0 : title.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '')) || '';
};
/**
 * SidebarItem - menus and sub menus organizer
 * @param {object} props
 * @returns
 */
function SidebarItem(props) {
  const {
    item,
    submenulevel,
    overrideToggle,
    external
  } = props;
  const [open, setOpen] = (0, _react.useState)(overrideToggle ? true : false);
  const [selectedParentId, setSelectedParentId] = (0, _react.useState)(props.selectedParentId);
  const [selectedSolutionId, setSelectedSolutionId] = (0, _react.useState)(props.selectedSolutionId);
  const [selectedId, setSelectedId] = (0, _react.useState)(props.selectedId);
  let subMenuLevel;
  let dataId;
  let dataTestId;
  let dataIdMenu;
  let dataTestIdMenu;
  const onhandleChange = props.onhandleChange;
  subMenuLevel = submenulevel ? submenulevel : 0;
  const handleClick = (0, _react.useCallback)(item => {
    if (overrideToggle) {
      return;
    }
    if (typeof props.handleCallback === 'function') {
      if (external) {
        //only for external portal
        if ((item === null || item === void 0 ? void 0 : item.type) === 'content' && (item === null || item === void 0 ? void 0 : item.subMenu) === null) {
          //callback only on different item clicked for non dropdown
          props.handleCallback(item);
        }
      } else {
        props.handleCallback(item);
      }
    }
  });
  // get current path to set 'active' and 'open state on dynamically built submenus
  const currentPath = window.location.href.replace(window.location.origin, '');
  (0, _react.useEffect)(() => {
    if (!overrideToggle) {
      if (subMenuLevel === 1) {
        setOpen(!open);
      }
      if (currentPath.includes((item === null || item === void 0 ? void 0 : item.sourcePath) && item.sourcePath) || currentPath.includes((item === null || item === void 0 ? void 0 : item.link) && item.link)) {
        setOpen(!open);
      }
    } else {
      setOpen(true);
    }
    if (selectedSolutionId) {
      setSelectedSolutionId(Number(props.selectedSolutionId));
    }
    if (selectedParentId) {
      setSelectedParentId(Number(props.selectedParentId));
    }
    if (selectedId) {
      setSelectedId(Number(props.selectedId));
    }
    (0, _MenuAction.onLoad)();
  }, []);
  if (item.subMenu) {
    subMenuLevel = subMenuLevel + 1;
    dataId = subMenuLevel === 1 ? slugForURL('parent' + '-' + item.name) : subMenuLevel === 2 ? 'subparent' : subMenuLevel === 3 ? 'child' : 'subchild';
    dataTestId = slugForURL(dataId + '-' + item.id);
    return /*#__PURE__*/_react.default.createElement("li", {
      className: open ? "sidebar-nav-item open level-".concat(subMenuLevel, "-item") : "sidebar-nav-item level-".concat(subMenuLevel, "-item"),
      onClick: onhandleChange
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (item === null || item === void 0 ? void 0 : item.type) == 'api-contract-parent' ? "sidebar-title api-contract level-".concat(subMenuLevel, "-item") : "sidebar-title level-".concat(subMenuLevel, "-item"),
      id: "".concat(slugForURL(item.name)),
      onClick: e => {
        if (!overrideToggle) {
          handleClick(item);
          (0, _MenuAction.collapseMenus)(e);
        } else {
          return;
        }
      },
      "data-testid": dataTestId
    }, (item === null || item === void 0 ? void 0 : item.type) == 'api-contract-parent' ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      className: "text-reset",
      to: item.link
    }, item.name) : /*#__PURE__*/_react.default.createElement("span", null, item.name), item.type === 'api-contract' && /*#__PURE__*/_react.default.createElement("span", {
      className: "badge_api badge_api--underline"
    }, item.version), /*#__PURE__*/_react.default.createElement("i", {
      className: "fa-solid fa-chevron-down bi-chevron-down toggle-btn",
      "data-testid": "chevron-icon-".concat(item.id)
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "sidebar-content"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "sidebar-nav-items level--".concat(subMenuLevel)
    }, item.subMenu.map((child, index) => /*#__PURE__*/_react.default.createElement(SidebarItem, {
      overrideToggle: overrideToggle,
      submenulevel: subMenuLevel,
      key: index,
      item: child,
      selectedId: props.selectedId,
      handleCallback: handleClick
    })))));
  } else {
    dataIdMenu = item.id === 0 || item.id === 1 ? slugForURL('parent' + '-' + item.name) : 'subchild';
    dataTestIdMenu = slugForURL(dataIdMenu + '-' + item.id);
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("li", {
      id: item.id,
      "data-testid": dataTestIdMenu
      //   onClick={onhandleChange}
      ,
      onClick: e => {
        onhandleChange;
        if (!overrideToggle) {
          handleClick(item);
          (0, _MenuAction.collapseMenus)(e);
        } else {
          return;
        }
      },
      className: props.selectedId === item.id || item.link === currentPath ? 'sidebar-nav-item sidebar-nav-item--active' : 'sidebar-nav-item'
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: item.link || '#',
      onClick: () => handleClick(item),
      className: "sidebar-title"
    }, item.type === 'api-contract' && methodSpan(item === null || item === void 0 ? void 0 : item.method), item.name)));
  }
}